import {formatDate, formatTime} from "@eventer/api-client/lib/esm/utils/datetime-util";

export interface FormatDateTimeRangeProps {
    startDate: Date;
    endDate?: Date;
}

export function formatDateTimeRange(props: FormatDateTimeRangeProps): string {
    const {startDate, endDate} = props;
    
    if (!endDate) {
        const dateText = formatDate({date: startDate});
        const timeText = formatTime({date: startDate});
        return `${dateText} ${timeText}`;
    }
    
    const timeDiff = endDate.getTime() - startDate.getTime();
    const hoursDiff = timeDiff / (1000 * 60 * 60);
    
    if (hoursDiff > 24) {
        const startDateText = formatDate({date: startDate});
        const startTimeText = formatTime({date: startDate});
        const endDateText = formatDate({date: endDate});
        const endTimeText = formatTime({date: endDate});
        return `${startDateText} ${startTimeText} - ${endDateText} ${endTimeText}`;
    } else {
        const startTimeText = formatTime({date: startDate, timeSuffix: null});
        const endTimeText = formatTime({date: endDate});
        const dateOnlyText = formatDate({date: startDate});
        return `${dateOnlyText} ${startTimeText} - ${endTimeText}`;
    }
}
